import * as type from './type';
import util from 'common/js/util';

export default{
  [type.CHECK_EDIT_AVAILABLE](context, option) {
    util.post({
      params: {
        functionId: 'validateEditDeliver',
        body: JSON.stringify(option.params)
      },
      sc(data) {
        if (option && option.sc) {
          option.sc(data);
        }
      },
      fc(data) {
        if (option && option.fc) {
          option.fc(data);
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/store/address-manage/actions.js